import { Badge } from "./badge";
import { cn } from "@/lib/utils";

type StatusType = "construction" | "evolution" | "ready";

interface StatusBadgeProps {
  status: StatusType;
  className?: string;
}

const statusConfig: Record<StatusType, { label: string; variant: "construction" | "evolution" | "ready" }> = {
  construction: { label: "Em Construção", variant: "construction" },
  evolution: { label: "Em Evolução", variant: "evolution" },
  ready: { label: "Apto", variant: "ready" },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status];
  
  return (
    <Badge variant={config.variant} className={cn("font-semibold", className)}>
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 bg-current" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-current" />
      </span>
      {config.label}
    </Badge>
  );
}
